export function byBoolean<T, K extends keyof T>(key: K) {
    return (a: T, b: T) => (a[key] === b[key]) ? 0 : a[key] ? -1 : 1;
};

export function byNumber<T extends { [p in K]: number }, K extends keyof T>(key: K) {
    return (a: T, b: T) => a[key] - b[key];
};
